/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { useInputState } from '@infotrack/presentacion-utilitarios/hooks';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import IPais from 'Infotrack@Modelos/administracion/pais/entidades/pais';
import React from 'react';
import PaisCM from '../controladorModelo/paisCM';
import { acciones, IEstadoPais } from '../reductorPais';
import FormularioPaisVista from '../vista/formularioPaisVista';

const estadoInicial: IPais = {
    CodigoPais: '',
    NombrePais: '',
    EstadoPais: true,
};
const paisCM = new PaisCM();

const FormularioPaisCV: React.FunctionComponent = () => {
    const [{ estadoFormulario, tipoFormulario, entidadPais }, dispatch] = useProveedor<IEstadoPais>();
    const { alCambiarValor, setValor, reiniciar, valor } = useInputState<IPais>(estadoInicial);

    React.useEffect(() => {
        if (entidadPais && tipoFormulario !== TipoFormulario.Creacion) {
            setValor(entidadPais);
        } else {
            reiniciar();
        }
    }, [entidadPais]);

    const cerrarFormulario = () => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: null });
    };
    const confirmarCreacionEdicionPais = () => {
        if (paisCM.validarEntidad(valor)) {
            manejadorDialogoGlobal({
                accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
                accionConfirmar: crearEditarPais,
                estado: true,
                mensaje: (
                    <Texto
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'alerta.confirmacionCreacion'
                                : 'alerta.confirmacionEdicion'
                        }
                    />
                ),
                mostrarCancelar: true,
                tipoDialogo: 'Advertencia',
                titulo: <Texto id="titulo.advertencia" />,
            });
        }
    };

    const crearEditarPais = () => {
        manejadorDialogoGlobal({ estado: false });
        manejadorIndicadorCargaGlobal(true);
        if (tipoFormulario === TipoFormulario.Creacion) {
            paisCM.crearPais(valor).then(() => {
                cerrarFormulario();
                manejadorIndicadorCargaGlobal(false);
                dispatch({ type: acciones.RECARGAR_TABLA });
            });
        } else {
            paisCM.editarPais(valor).then(() => {
                cerrarFormulario();
                manejadorIndicadorCargaGlobal(false);
                dispatch({ type: acciones.RECARGAR_TABLA });
            });
        }
    };

    return (
        <FormularioPaisVista
            accionCrearEditar={confirmarCreacionEdicionPais}
            cambiarInfoFomulario={alCambiarValor}
            pais={valor}
            cerrarFormulario={cerrarFormulario}
            estadoFormulario={estadoFormulario}
            tipoFormulario={tipoFormulario}
        />
    );
};

export default FormularioPaisCV;
